import Axios from "axios"
import { TIMEOUT } from "../../constants"
import { errorHandler } from "../../utils"

const { default: api } = require("../../api")

const systemService = {
  async getAll(){
    const config = {
      timeout: TIMEOUT,
      headers: {
        'X-Api-Key': api.key,
      }
    }

    return new Promise(function(resolve, reject){
      Axios.get(api.base+api.system_list, config)
        .then(res => {
          if(res.data.results){
            resolve(res.data.results)
          }
          else if(res.data){
            resolve(res.data)
          }
          else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
    })
  },
}

export default systemService
